module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/tp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/authorsnote"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/p01"
    }
  }, [_vm._v("Not That Kind of War")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/p02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Do What You Do")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/p03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First In")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/p04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Dust We Shall Return")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/p05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long Time Passing")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/alsoby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Tanya Huff")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c076ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0